<template>
  <div v-if="tip" class="flex flex-start my-2">
    <div
      class="devtip-checkbox-wrapper mr-3"
      :class="{ 'devtip-checkbox-clickable': !isDone }"
      @click="!isDone && showFeedbackForm(tip.text)"
    >
      <Checkbox :modelValue="isDone" binary disabled size="medium"
          class="devtip-status-checkbox" :class="isNewTip"/>
    </div>
    <div class="flex flex-col cursor-pointer"
      v-on="showFeedback ? { click: () => showFeedbackForm(tip.text) } : {}">
      <p class="mb-0"><b>{{ tip.title?.[getLocale] ?? '-' }}</b></p>
      <div class="flex text-xs">
        <p class="text-[var(--color-orange)] mr-1">{{ tip.dimension?.[getLocale] ?? '-' }}</p>
        <p class="text-[var(--color-disabled)]">
            {{ $t('DevTipItemComponent.recievedAt') }} {{ getDate }}</p>
      </div>
      <p v-if="showText" class="mt-1 text-md">
        <span v-html="tip.text?.[getLocale] ?? '-'"></span></p>
    </div>
    <FeedbackOverlayComponent v-if="showFeedbackDialog" :visible="showFeedbackDialog"
    @update:visible="showFeedbackDialog = $event"
     @confirmed="onFeedbackConfirmed" :data="notification"></FeedbackOverlayComponent>
  </div>
  <Divider/>
</template>

<script>
import { Checkbox, Divider } from 'primevue';
import FeedbackOverlayComponent from '../FrontendOverlays/FeedbackOverlayComponent.vue';

export default {
  name: 'DevTipItemComponent',
  components: { Checkbox, Divider, FeedbackOverlayComponent },
  props: {
    tip: {
      type: Object,
      default: null,
    },
    showText: {
      type: Boolean,
      default: false,
    },
    overlayId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      showFeedbackPopup: true,
      showFeedbackDialog: false,
      notification: {},
    };
  },
  computed: {
    isDone() {
      return Boolean(this.tip?.done);
    },
    getDate() {
      const date = new Date(this.tip.date);
      return `${(`0${date.getDate()}`).slice(-2)}.${(`0${date.getMonth() + 1}`).slice(-2)}.${date.getFullYear()}`;
    },
    getLocale() {
      return this.$i18n.locale;
    },
    showFeedback() {
      return this.showFeedbackPopup; // && !this.tip.feedbackGiven;
    },
    isNewTip() {
      return (this.tip.new) ? 'border: 1px solid var(--color-orange) !important;' : '';
    },
  },
  methods: {
    showFeedbackForm(text = '') {
      try {
        this.notification = {
          helpful: this.tip?.positive,
          text,
          tipId: this.tip?.tip_id,
          feedback_text: this.tip?.feedback_text,
          done: this.tip?.done,
        };
        // this.$store.commit('setShowDevTipps', false);
        this.showFeedbackDialog = true;
        if (this.overlayId) {
          // this.$store.commit('removeFrontendOverlay', this.overlayId);
        }
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('DevTipItemComponent.errorCouldNotFeedback'),
          detail: '',
          life: 3000,
        });
      }
    },
    onFeedbackConfirmed() {
      // Reset the feedback dialog state after feedback is submitted
      this.showFeedbackDialog = false;
      // Emit event to parent to refresh the DevTip list
      this.$emit('feedback-submitted');
    },
  },
};
</script>

<style scoped>
/* When not done, clicking the checkbox opens feedback (same as clicking the tip) */
.devtip-checkbox-clickable {
  cursor: pointer;
}
.devtip-checkbox-clickable :deep(.p-checkbox) {
  pointer-events: none;
}

/* White checkmark only (box keeps theme color), bold */
.devtip-status-checkbox :deep(.p-checkbox-icon) {
  color: white !important;
  font-weight: bold !important;
}
.devtip-status-checkbox :deep(.p-checkbox-icon path) {
  fill: white !important;
  stroke: white;
  stroke-width: 1.5px;
  stroke-linecap: round;
  stroke-linejoin: round;
  paint-order: stroke fill;
}
</style>
